import { HtmlContentHeuristic } from '../../../interfaces/html-content-heuristic';

// break on all, for testing purposes!
export const breakOnAll: HtmlContentHeuristic = {
  reason: 'breaking on all',
  evaluate: () => true,
  properties: []
};
